// Default Supabase client_id used by the AIM dashboard when no project is
// selected (or the selected project has no supabase_client_id mapping).
// Change this single value to point AIM at a different campground.
const AIM_DEFAULT_CLIENT_ID = 'cd94da9a-42af-4c73-8b6a-467469e23cbe';

export function getAimDefaultClientId() {
  return AIM_DEFAULT_CLIENT_ID;
}
